<template>
	<div>
		<template v-if="user._userRestricted === true">
			<v-alert
				type="info"
				class="ma-3"
			>
				Maksamalla jäsenmaksun pääset käsiksi kattaviin jäsenetuihin sekä materiaaleihin.
			</v-alert>
		</template>
		<template v-else>
			<!-- Output child page -->
			<router-view />

			<!-- Output navigation if we're not on child page -->
			<template v-if="$route.name == 'pageCategoryContainer'">
				<v-container class="py-6">
					<v-row
						no-gutters
						class="fill-height"
						align="center"
					>
						<v-col
							cols="12"
							class="pa-3"
						>
							<v-card
								class="amber lighten-4"
								height="100%"
							>
								<v-card-title>
									<span style="word-break: break-word;">Suomen Ratsastajainliiton koulutusalusta ja materiaalipankki</span>
								</v-card-title>
								<v-divider />
								<v-divider />
								<v-card-actions>
									<v-btn
										color="black"
										text
										href="https://ratsastus.mmg.fi/login/index.php"
										target="_blank"
									>
										<v-icon
											left
										>
											mdi-open-in-new
										</v-icon>
										Siirry Kaviouraan
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-col>
					</v-row>
				</v-container>

				<v-container
					v-if="items.length"
					class="py-6"
				>
					<v-row
						no-gutters
					>
						<v-col
							v-for="item in items"
							:key="item.id"
							cols="12"
							sm="6"
							md="4"
							xl="3"
							class="pa-3"
						>
							<v-card
								:to="{ name: 'pageCategory', params: { categoryname: item.name } }"
								:class="[
									item.highlight === 1 ? 'yellow lighten-4' : null,
								]"
								height="100%"
							>
								<v-row
									no-gutters
								>
									<v-col
										:cols="(item.logo) ? 8 : 12"
										class="py-3"
									>
										<v-card-title
											v-if="item.title"
											class="pt-0"
										>
											<span v-html="item.title" />
										</v-card-title>
										<v-card-text
											v-if="item.summary"
										>
											<span v-html="item.summary" />
										</v-card-text>
									</v-col>
									<v-col
										v-if="item.logo"
										cols="4"
										class="pa-3"
									>
										<v-img
											:src="item.logo.url"
											contain
										/>
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
				<v-alert
					v-else
					type="info"
					class="ma-3"
				>
					Ei sivuja
				</v-alert>
			</template>
		</template>
	</div>
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'PageCategoryContainer',
	computed: {
		...mapState({
			user: state => state.user,
			items: state => state.pages,
		}),
	},
	methods: {
		itemClick (item) {
			this.$router.push({ name: 'page', params: { pagename: item.name } })
		},
	},
	mounted () {
		this.$api.Pages.doRequest()
	},
}
</script>
